<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="currency">
                <wbo-entity-availability-single-select-search-control [activeName]="'current'"
                                                                      [inactiveName]="'non-current'"></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="availability">
                <wbo-entity-availability-single-select-search-control [activeName]="'available'"
                                                                      [inactiveName]="'unavailable'"></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'cardGroup'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-column field="appCardName"></wbo-column>
        <wbo-column field="cardType"></wbo-column>
        <wbo-column field="cardGroup"></wbo-column>
        <wbo-checkbox-column field="currentCard"></wbo-checkbox-column>
        <wbo-checkbox-column field="cardAvailable"></wbo-checkbox-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>

